export default __webpack_public_path__ + "static/media/instructions-3.72287aed.svg";